<template>
  <div class="cx-category-api-header">
    <div />
    <div  v-for="(frame, index) in getTimeFrames"
          :key="index"
          class="local-header-text">
      {{ frame }}</div>
    <div />
  </div>
</template>

<script>
import CxDashboardContentMixin from "@/mixins/jlr/CxDashboardContentMixin.js";
import moment from "moment";

export default {
  mixins: [ CxDashboardContentMixin ],

  props: {
    afsData:            { type: Object, default: () => undefined },
    apis:               { type: Array, required: true },
    explorationData:    { type: Array, required: true },
    nonAfsData:         { type: Object, default: () => undefined },
  },

  computed: {
    getTimeFrames() {
      try {
        if (this.isApi(this.apis[0])) {
          let items = [...this.explorationData[0].OverallScores.slice(1, 4), {}, {}, {}].slice(0,3).reverse();
          return [
            ...items.map(x => moment(x.Date).format('MMM yyyy')),
            this.$t('Webportal.CX.Dashboard.Exploration.CurrentValue')];
        }

        if (this.isExploration(this.apis[0])) {
          let items = [...this.apis[0].WaveResults.slice(0, 3), {}, {}, {}].slice(0,3).reverse();
          return [
            ...items.map(x => x.WaveNameShort),
            this.$t('Webportal.CX.Dashboard.Exploration.LastCheck')];
        }

        if (this.isNonExploration(this.apis[0])) {
          return [ 
            this.$t('Webportal.CX.Dashboard.LastWaves'),
            this.$t('Webportal.CX.Dashboard.Exploration.LastCheck')];
        }
        
        return [ "", "", "", this.$t("Webportal.CX.Dashboard.Exploration.CurrentValue") ];
      } catch (error) {
        console.error(error)
      }
    }
  },

}
</script>

<style lang="scss" scoped>

.local-item {
  border-top: 1px solid white;
}
.local-header-text {
  text-align: center;
  font-weight: bold;
}

.local-image {
  max-width: 110px; 
  max-height: 35px;
}
</style>